import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceNews {
    lookupService = new APIServiceLookUp();

    async getAllNews(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}news/getAllNews`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setNews(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}news/setNews`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateNews(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}news/updateNews`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delNews(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}news/delNews`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
